import React from 'react';
import AsyncSelect from 'react-select/async';
import { FormGroup, FormFeedback, Label } from 'reactstrap';
import { Trans } from '@lingui/macro';

export default function RFReactSelectAsync({
    input,
    options,
    multi,
    className,
    label,
    getOptions,
    feedbackIcon,
    autoload = false,
    meta: { error, warning, touched },
}) {
    const { name, value, onBlur, onChange, onFocus } = input;
    const transformedValue = transformValue(value, options, multi);

    let message;

    if (touched && (error || warning)) {
        message = <span className="help-block">{error || warning}</span>;
    }

    return (
        <FormGroup>
            <Label>{label}</Label>
            <AsyncSelect
                loadOptions={getOptions}
                name={name}
                value={transformedValue}
                isMulti={multi}
                autoload={autoload}
                className={className}
                placeholder={<Trans>Välj</Trans>}
                cacheOptions
                onChange={multi ? multiChangeHandler(onChange) : singleChangeHandler(onChange)}
            />
            {feedbackIcon ? <FormFeedback>{feedbackIcon}</FormFeedback> : null}
            {message}
        </FormGroup>
    );
}

/**
 * onChange from Redux Form Field has to be called explicity.
 */
function singleChangeHandler(func) {
    return function handleSingleChange(value) {
        func(value ? value.value : '');
    };
}

/**
 * onBlur from Redux Form Field has to be called explicity.
 */
function multiChangeHandler(func) {
    return function handleMultiHandler(values) {
        func(values.map((value) => value.value));
    };
}

/**
 * For single select, Redux Form keeps the value as a string, while React Select
 * wants the value in the form { value: "grape", label: "Grape" }
 *
 * * For multi select, Redux Form keeps the value as array of strings, while React Select
 * wants the array of values in the form [{ value: "grape", label: "Grape" }]
 */
function transformValue(value, options, multi) {
    if (multi && typeof value === 'string') return [];
    if (!options) return { value: value, label: value };

    const filteredOptions = options.filter((option) => {
        return multi ? value.indexOf(option.value) !== -1 : option.value === value;
    });

    return multi ? filteredOptions : filteredOptions[0];
}
